import { createTriage } from "../patientSaga";

export const FORM_FIELDS_NAMES = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  BSA_ID: "bsaId",
  DOB: "dateOfBirth",
  EMAIL: "email",
  CONTACT_NUMBER: "contact",
  GENDER: "gender",
  CLINIC_LOCATION: "clinicLocation",
  JAMBOREE_UNIT_NUMBER: "jamboreeUnitNumber",
  JAMBOREE_UNIT_LEADER_NAME: "jamboreeUnitLeaderName",
  JAMBOREE_UNIT_LEADER_EMAIL: "jamboreeUnitLeaderEmail",
  EMERGENCY_CONTACT_NAME: "emergencyContactName",
  EMERGENCY_CONTACT_RELATION: "emergencyContactRelation",
  EMERGENCY_EMAIL: "emergencyEmail",
  EMERGENCY_CONTACT_NUMBER: "emergencyContactNumber",
};

export const EMERGENCY_CONTACT_RELATIONS = [
  { label: "Father", value: "Father" },
  { label: "Mother", value: "Mother" },
  { label: "Self", value: "Self" },
];

export const GENDER = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

// CREATE TRIAGE FUNCTION
export const createTriageClick = (
  formData: any,
  patientId: any,
  visitId: any,
  dispatch: any
) => {
  const payload = {
    apiPayload: {
      patientId: patientId,
      visitId: visitId,
      // Only send vitals that were actually entered (omit blanks).
      temperature: formData?.temperature
        ? Number(formData?.temperature)
        : undefined,
      oxygenSaturation: formData?.oxygenSaturation
        ? Number(formData?.oxygenSaturation)
        : undefined,
      heartRate: formData?.heathRate ? Number(formData?.heathRate) : undefined,
      respirationRate: formData?.respirationRate
        ? Number(formData?.respirationRate)
        : undefined,
      systolic: formData?.bloodPressure
        ? Number(formData?.bloodPressure)
        : undefined,
      diastolic: formData?.bloodPressure2
        ? Number(formData?.bloodPressure2)
        : undefined,
      woundCare: formData?.care === "woundCare" ? true : false,
      woundlocation: formData?.care === "woundCare" ? formData?.careValue : "",
      dehydration: formData?.care === "dehydration" ? true : false,
      dehydrationLevel:
        formData?.care === "dehydration" ? formData?.careValue : "",
      injury: formData?.care === "injury" ? true : false,
      injurylocation: formData?.care === "injury" ? formData?.careValue : "",
      other: formData?.care === "other" ? true : false,
      details: formData?.care === "other" ? formData?.careValue : "",
      triageTakenBy: formData?.triageTakenId,
      location: formData?.triageTakenLocation
        ? formData?.triageTakenLocation === "clinicLocation"
          ? "Clinic Location"
          : "JHC"
        : undefined,
    },
    comesFrom: "patientScreen",
  };
  dispatch(createTriage(payload));
};
